export default {
    INVALID_DATA: 'Ungültige Crafting-Daten, bitte reiche einen Fehlerbericht ein.',
    INVALID_ITEM: 'Ungültigen Gegenstand ausgewählt.',
    INVALID_ITEMS: 'Du hast nicht die erforderlichen Gegenstände, um dies herzustellen.',
    SELECT_ITEM: 'Bitte wähle einen Gegenstand zum herstellen aus.',
    FAILED_CRAFT: 'Dir ist es nicht gelungen, {{failedText}} herzustellen',
    FAILED_CRAFT_ONE: 'Dir ist es nicht gelungen, den Gegenstand herzustellen.'
} as const;
